'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exportBoard = exports.triggerDownload = undefined;

var _exportConstants = require('./exportConstants');

var _browser = require('../../../../utils/services/browser');

var _mediaService = require('../../../../utils/services/mediaService');

var _mediaService2 = _interopRequireDefault(_mediaService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCanvasDomHTML = function getCanvasDomHTML() {
    var rootElement = document.getElementById(_exportConstants.EXPORT_ROOT_ELEMENT_ID);
    var body = document.body;

    if (!rootElement) return;

    var rootHTML = rootElement.outerHTML;
    var html = '<div class="CanvasExport ' + body.classList.value + '">' + rootHTML + '</div>';

    return JSON.stringify({
        html: html,
        height: rootElement.clientHeight,
        width: rootElement.clientWidth
    });
};

var createLink = function createLink(url) {
    // attempt to dowload the file by creating a fake link and clicking on it
    var urlParts = url.split('/');
    var filename = urlParts[urlParts.length - 1];

    var link = document.createElement('a');
    link.href = url;
    link.target = '_self';
    link.download = filename;

    return link;
};

var triggerLink = function triggerLink(link) {
    link.click();
};

var triggerLinkFirefox = function triggerLinkFirefox(link) {
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

var triggerDownload = exports.triggerDownload = function triggerDownload(url) {
    var link = createLink(url);
    (0, _browser.isFirefox)() ? triggerLinkFirefox(link) : triggerLink(link);
};

var exportBoard = exports.exportBoard = function exportBoard(_ref) {
    var boardId = _ref.boardId,
        format = _ref.format;
    return function (dispatch, getState) {
        dispatch({ type: _exportConstants.EXPORT_BOARD_FETCH, format: format });

        var htmlDOM = format === 'pdf-html' ? getCanvasDomHTML() : undefined;

        return _mediaService2.default.export.exportBoard({ boardId: boardId, format: format, htmlDOM: htmlDOM }).then(function (_ref2) {
            var data = _ref2.data;

            var url = data.fileURL;
            if (!url) return dispatch({ type: _exportConstants.EXPORT_BOARD_FAIL, format: format });

            dispatch({ type: _exportConstants.EXPORT_BOARD_SUCCESS, format: format, url: url });

            triggerDownload(url);
        }).catch(function (error) {
            dispatch({ type: _exportConstants.EXPORT_BOARD_FAIL, format: format });
            Promise.reject(error);
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/export/exportPopupActions.js
// module id = 2179
// module chunks = 0